import { Component, Inject, SecurityContext } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { INoticeDialogData } from '../../models/interfaces';

@Component({
    selector: 'notice-dialog',
    templateUrl: './notice-dialog.component.html',
    styleUrls: ['./notice-dialog.component.scss'],
    standalone: false
})
export class NgxNoticeDialogComponent {
    private _defaults: INoticeDialogData;
    public config: INoticeDialogData;

    constructor (
        private _sanitizer: DomSanitizer,
        private _NgxNoticeDialogComponent: MatDialogRef<NgxNoticeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: INoticeDialogData
    ) {
        this._defaults = {
            text: {
                body: 'Success!'
            },
            showClose: true,
            controls: []
        };

        this.config = Object.assign(this._defaults, this._data);
        this.config.text.body = this._sanitizer.sanitize(SecurityContext.HTML, this.config.text.body);
    }

    close = () => {
        this._NgxNoticeDialogComponent.close();
    };

    onButtonPress = (clickEvent, customFn: Function = this.close) => {
        customFn(clickEvent, this);
    };
}
